const { logger: obsLogger } = require('@fiverr-private/obs');
const { extractRecommendationsParams } = require('./utils');

const appname = 'personalized-content';
const subsystemname = appname;
let consumerFunnelName = 'unset';
let consumerSectionName = 'unset';

const getSharedEnrichment = () => ({
    appname,
    subsystemname,
    consumer_funnel_name: consumerFunnelName,
    consumer_section_name: consumerSectionName,
});

const logger = {
    warn: (entity, enrichment) => obsLogger.warn(entity, { ...enrichment, ...getSharedEnrichment() }),
    error: (entity, enrichment) => obsLogger.error(entity, { ...enrichment, ...getSharedEnrichment() }),
    info: (entity, enrichment) => obsLogger.info(entity, { ...enrichment, ...getSharedEnrichment() }),
    setLoggerConsumerData: ({ funnelName, sectionName }) => {
        consumerFunnelName = funnelName;
        consumerSectionName = sectionName;
    },
};

module.exports = { logger, extractRecommendationsParams, appname, subsystemname };
